define('models/zendesk/FieldModel',['underscore','ObjectModel','LocalStorage','app','string','moment'],
    function (_,ObjectModel,LocalStorage,app, S, moment) {
    //
    // Model Zendesk Field
    //

    var _TYPE_ALIAS_FIRSTNAME_ = 'firstname',
        _TYPE_ALIAS_LASTNAME_ = 'lastname',
        _TYPE_ALIAS_EMAIL_ = 'email',
        _TYPE_ALIAS_UPLOAD_ = 'upload',
        _TYPE_ALIAS_PHONE_ = 'phone',
        _TYPE_ALIAS_COMEIN_ = 'comein';


    return ObjectModel.extend({

        name:'ZendeskFieldModel',
        idAttribute:'id',
        defaults:{
            visible_in_portal:true,
            required_in_portal:true,
        },

        isVisible: function(){
            var model = this,
                visible_in_portal = model.get('visible_in_portal'),
                type = model.get('type');
            return visible_in_portal && _(['integer','text','tagger','date','description',_TYPE_ALIAS_EMAIL_,_TYPE_ALIAS_UPLOAD_]).contains(type);
        },

        getIcon: function(){
            var icon = 'edit';
            switch(this.getTypeAlias()){
                case _TYPE_ALIAS_FIRSTNAME_:
                case _TYPE_ALIAS_LASTNAME_:
                    icon = 'user';
                    break;
                case _TYPE_ALIAS_PHONE_:
                    icon = 'phone';
                    break;
                case _TYPE_ALIAS_EMAIL_:
                    icon = 'message';
                    break;
                case _TYPE_ALIAS_COMEIN_:
                    icon = 'comein';
                    break;
            }

            return icon;
        },

        getTypeAlias: function(){
            function getAliasId(configuration, defaultValue){
                return parseInt(app.c(configuration,defaultValue));
            }
            var typeAlias = 'default',
                id = this.id,
                firstname_id = getAliasId("_ZENDESK_FIRSTNAME_ID_", 31017049),
                lastname_id = getAliasId("_ZENDESK_LASTNAME_ID_", 31017009),
                phone_id = getAliasId("_ZENDESK_PHONE_ID_", 31015809),
                comein_id = getAliasId("_ZENDESK_COMEIN_ID_", 31015849);
            //
            switch(id) {
                case _TYPE_ALIAS_EMAIL_:
                case _TYPE_ALIAS_UPLOAD_:
                    typeAlias = id;
                    break;
                case firstname_id:
                    typeAlias = _TYPE_ALIAS_FIRSTNAME_;
                    break;
                case lastname_id:
                    typeAlias = _TYPE_ALIAS_LASTNAME_;
                    break;
                case phone_id:
                    typeAlias = _TYPE_ALIAS_PHONE_;
                    break;
                case comein_id:
                    typeAlias = _TYPE_ALIAS_COMEIN_;
                    break;
            }
            return typeAlias;
        },

        getValue: function(){
            var preset_value = '',
                typeAlias = this.getTypeAlias(),
                customer = app.getCustomer();
            //
            // preset
            //
            switch(typeAlias){

                case _TYPE_ALIAS_EMAIL_:
                    preset_value = customer.getEmail();
                    break;
                case _TYPE_ALIAS_FIRSTNAME_:
                    preset_value = customer.getFirstname();
                    break;
                case _TYPE_ALIAS_LASTNAME_:
                    preset_value = customer.getLastname();
                    break;
                case _TYPE_ALIAS_PHONE_:
                    preset_value = customer.getPhone();
                    break;
                case _TYPE_ALIAS_COMEIN_:
                    var neolaneAccount = customer.getNeolaneParam('account',0);
                    if (neolaneAccount){
                        preset_value = neolaneAccount;
                    }
                    break;

            }
            return preset_value;
        },

        isSelectDivided:function(){
            // est-ce qu'on divise le select en 2 étapes
            var motif_field_list =  app.c('_ZENDESK_FIELD_MOTIF_');
            motif_field_list = motif_field_list.split(',');
            return motif_field_list.indexOf(this.get('id').toString()) !== -1;
        },

        getSelectId:function(){
            return this.id + (this.isSelectDivided() ? '_div':'');
        },

        getMotifId:function(){
            //
            // retourne le motif sélectionné
            // par défault de l'article affiché sur le centre d'aide
            //
            var currentArticle = this.collection.supportCenter.getCurrentArticle();
            return currentArticle ? currentArticle.getMotifId() : false;
        },
        formatValue:function(value){
            switch(this.get('type')){
                case 'date':
                    var date = moment(value,'DD/MM/YYYY');
                    if(date.isValid()){
                        value = date.format('YYYY-MM-DD');
                    }
                    break;
            }
            return value;
        },

        getSelectOptions:function(){

            var custom_field_options = this.get('custom_field_options'),
                id_motif = this.getMotifId(),
                use_division =  this.isSelectDivided();
            var fields = _(custom_field_options).map(function(opt){
                var name = opt.name,
                    value = opt.value,
                    id = opt.id,
                    selected = id_motif == id,
                    group = false,
                    option,
                    division;

                // gestion de select divisé en 2 parties
                if(use_division){
                    division = name.split('::');
                    name = division[1] || division[0];
                    group = division[0];
                }

                option = {
                    label:name,
                    value:value,
                    group:group,
                    selected:selected
                };

                return option;
            });

            if(use_division){
                // si on divise en groupes
                var groups = _(fields).groupBy('group');
                fields = _(groups).map(function(group,name){
                    var opt;
                    if(group.length>1){
                        opt = {
                            label:name,
                            size:group.length,
                            group:_(group)
                        }
                    }else{
                        // groupe automatiquement les sous-groupe qui n'ont qu'un élement
                        opt = group[0]
                    }
                    return opt;
                });
            }

            return _(fields);
            //<option value="<%= option.value %>"><%= option.name %></option>

        },

        getId:function(){
            var id = this.id, r = 'field__'+id;
            switch (id){
                case 'upload':
                case 'email':
                    r = id;
            }
            return r;
        },

        getUI:function(){
            var input = 'text', type = this.get('type');
            //
            if(type === 'upload'){
                input = 'upload';
            }
            if(type === 'description'){
                input = 'textarea';
            }
            if(type === 'date'){
                input = 'date';
            }
            if(type === 'tagger'){
                input = 'select';
            }
            return input;
        },

        isRequired:function(){
            return this.get('required_in_portal') == true;
        },

        getRequiredAttr:function(){
            return this.isRequired() ? 'data-required="1"':'';
        },

        getLabel:function(ignoreAsterisk){
            ignoreAsterisk = ignoreAsterisk === true;
            return this.get('title')+((this.isRequired() && !ignoreAsterisk)?' *':'');
        },

        validate:function(value){
            var model = this, valid = true, response = {id:model.id};
            switch (model.getUI()){
                case 'date':
                    if(!!value) {
                        // date valide entre 1900 et 2099
                        var dateParts = /^[0123]?\d\/[012]?\d\/(19|20)\d{2}$/.exec(value);
                        // noop
                        if (!dateParts) {
                            valid = false;
                        } else {
                            valid = moment(value,'DD/MM/YYYY').isValid()
                        }
                        if (!valid) {
                            response.error = app.t('Veuillez saisir une date au format JJ/MM/AAAA', 'SupportCenter');
                        }
                    }
                    break;
            }
            if(valid && model.isRequired()){
                valid = (S(value).trim().s !== '');
                if(!valid){
                    response.error = app.t('Le champs %s est requis','UI',model.get('title'));
                }
            }
            response.valid = valid;
            return response;
        }

    })
});
